import { render, staticRenderFns } from "./content-detail.vue?vue&type=template&id=e3175d52&scoped=true&"
import script from "./content-detail.vue?vue&type=script&lang=js&"
export * from "./content-detail.vue?vue&type=script&lang=js&"
import style0 from "./content-detail.vue?vue&type=style&index=0&id=e3175d52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3175d52",
  null
  
)

export default component.exports